export default __webpack_public_path__ + "d4d6ce1b068eac5f169ff5eec74de6bf.png";